import {
  bigIssueTheme,
  farteTheme,
  gjovikTheme,
  mobyTheme,
  sefaTheme,
  shareBikeTheme,
  shematicTheme,
  sigoTheme,
  weelzTheme,
} from "@/constants/WhiteLabelTheme";
import { isDevEnvironment } from "@/utils/environment";
import { WhitelabelCodeReturnDecide } from "@/utils/utils";
import { useAdminDetails, useWhiteLabelCode } from "@/v2/stores";

export const useTheme = () => {
  const whiteLabelCode = useWhiteLabelCode();
  const adminDetails = useAdminDetails();

  const isSuperAdmin =
    adminDetails?.cityId === null && adminDetails?.whiteLabelId === null;
  let localStorageWhitelabel: string | null = null;
  if (typeof window !== "undefined") {
    try {
      const stored = localStorage.getItem("whitelabelName");
      localStorageWhitelabel = stored ? JSON.parse(stored) : null;
    } catch {
      localStorageWhitelabel = null;
    }
  }

  const effectiveWhitelabel =
    isSuperAdmin && localStorageWhitelabel
      ? localStorageWhitelabel
      : whiteLabelCode;

  if (effectiveWhitelabel === null && isDevEnvironment()) {
    return shematicTheme;
  }

  return WhitelabelCodeReturnDecide(effectiveWhitelabel, [
    shareBikeTheme,
    mobyTheme,
    bigIssueTheme,
    farteTheme,
    sigoTheme,
    sefaTheme,
    weelzTheme,
    gjovikTheme,
  ]);
};
